import { render, staticRenderFns } from "./BaseEventLogItem.vue?vue&type=template&id=4de8e092&scoped=true&"
import script from "./BaseEventLogItem.vue?vue&type=script&lang=js&"
export * from "./BaseEventLogItem.vue?vue&type=script&lang=js&"
import style0 from "./BaseEventLogItem.vue?vue&type=style&index=0&id=4de8e092&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de8e092",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
